module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_02_770_280_vi-b2ca38b3bd7800e697e20d0c03dacb3e.jpg";